const capitalize = (text) => text.charAt(0).toUpperCase() + text.slice(1);

// Fecha de hoy en formato "YYYY-MM-DD" usando componentes locales (no UTC),
// lista para usarse como atributo `min` de un <input type="date">.
export const getTodayISODate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// Recibe "YYYY-MM-DD" (valor de un <input type="date">) y lo formatea en español,
// construyendo la fecha con componentes locales para evitar el corrimiento de un día
// que causa `new Date("YYYY-MM-DD")` al interpretarla como UTC.
export const formatFechaBonita = (fecha) => {
  if (!fecha) return "";
  const [year, month, day] = fecha.split("-").map(Number);
  if (!year || !month || !day) return "";
  const dateObj = new Date(year, month - 1, day);
  const texto = dateObj.toLocaleDateString("es-CO", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  return capitalize(texto);
};

// Recibe "HH:MM" (valor de un <input type="time">) y lo formatea en formato de 12h.
export const formatHoraBonita = (hora) => {
  if (!hora) return "";
  const [hours, minutes] = hora.split(":").map(Number);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return "";
  const dateObj = new Date();
  dateObj.setHours(hours, minutes, 0, 0);
  return dateObj.toLocaleTimeString("es-CO", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};
